<template>
  <div style="width: 100%; position: relative">
    <div class="d-flex" style="width: 100%; justify-content: space-between">
      <b-form-input
        v-model="searchContent"
        autocomplete="off"
        :placeholder="defaultPlaceholder"
        style="width: 100%; padding: 0 5px; background-color: transparent !important; color: rgb(0, 0, 0)"
        :class="[
          errorMessage !== null && errorMessage !== ''
            ? 'errorStyle'
            : 'normalStyle'
        ]"
        :disabled="disabled"
        @click.stop="handleSelectShow()"
        @keyup.enter="handleSelectShow()"
      ></b-form-input>
    </div>
    <div v-show="selectShow" class="select_list">
      <div v-show="isEmpty" class="no_select_list">検索対象がありません</div>
      <ul class="list-unstyled ulstyle">
        <li v-for="(item, index) in courtList" :key="index" class="check_li">
          <div @click="handleCheckItem(item)" tabindex="0" @keyup.enter="handleCheckItem(item)">
            {{ item.courtName }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourtInputAssistance',
  model: {
    event: 'update'
  },
  props: {
    // 裁判所リスト
    courtData: {
      default() {
        return []
      },
      type: Array
    },
    // 非活性フラグ
    disabled: {
      default() {
        return false
      },
      type: Boolean
    },
    // エラーメッセージ
    errorMessage: {
      default() {
        return ''
      },
      type: String
    }
  },
  data() {
    return {
      courtList: [], // 裁判所リスト
      selectShow: false, // ドロップダウン表示
      searchContent: '', // コンテンツの検索
      isEmpty: false, // 取得結果がNULLかどうか
      isChecked: false, // 選択するかどうか
      defaultPlaceholder: '追加', // ﾌﾟﾚｰｽﾎﾙﾀ
      courtItem: {
        courtId: '',
        courtKindId: '',
        courtName: ''
      } // 裁判所が選択しなかった
            }
  },
  watch: {
    // コンテンツの検索
    searchContent: {
      handler(newVal) {
        if (newVal === '') {
          // すべて裁判所の情報
          this.courtList = this.courtData
          // 「検索対象がありません」(非表示)
          this.isEmpty = false
          // 選択した裁判所の情報を空にする
          this.$emit('getCheckItem', this.courtItem)
        } else {
          this.courtSearch(newVal)
        }
      }
    },
    courtData: {
      deep: true,
      handler() {
        // 裁判所の情報
        this.courtList = this.courtData
      }
    }
  },
  mounted() {
    this.courtList = this.courtData
    document.addEventListener('click', e => {
      // 入力ボックス以外の場所をクリックしてもドロップダウンボックスは表示されません
      this.selectShow = false
      // 裁判所が選択されている場合は裁判所が表示され、そうでない場合は空
      this.searchContent = this.isChecked ? this.searchContent : ''
    })
  },
  methods: {
        /**
     * 裁判所検索
     * @param val 検索内容
     */
    courtSearch(val) {
      this.courtList = this.courtData.filter(item => {
        const value = val.replace(/\(/g, '\\(').replace(/\)/g, '\\)')
        const reg = new RegExp(value)
        return reg.test(item.courtName)
      })
      // 裁判所名リスト
      const courtNameList = this.courtList.map(item => {
        return item.courtName
      })
      // 入力ボックスの検索内容が裁判所リストに含まれているかどうかを判断する
      const isHasCourt = courtNameList.includes(val)
      if (isHasCourt) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
      if (this.courtList.length === 0) {
        // 取得結果がNULLの場合、「検索対象がありません」のメッセージが表示されています
        this.isEmpty = true
      } else {
        // 上記以外の場合、メッセージが表示されていません
        this.isEmpty = false
      }
    },
    /**
     * 裁判所選択
     * @param item 選択
     */
    handleCheckItem(item) {
      this.isChecked = true
      this.selectShow = false
      this.searchContent = item.courtName
      this.$emit('getCheckItem', item)
    },
    /**
     * プルダウン表示
     */
    handleSelectShow() {
      this.courtList = this.courtData
      // プルダウン表示
      this.selectShow = !this.selectShow
      // 裁判所検索
      this.courtSearch(this.searchContent)
      // 入力ボックス制限入力の場合、プルダウン非表示
      if (this.disabled === true) {
        this.selectShow = false
      }
        }
  }
}
</script>

<style scoped lang="scss">
:focus {
  color: #fff;
  outline: 0 !important;
  box-shadow: var(--bs-btn-focus-box-shadow);
  background-color: rgb(25, 103, 210);
}
.select_list {
  width: 100%;
  max-height: 130px;
  overflow-y: auto;
  overflow-x: hidden;
  opacity: 1;
  position: absolute;
  top: 22px;
  background-color: #fff;
  z-index: 9999;
  border: 1px solid #dbd8d8;
  border-radius: 0px 0px 4px 4px;
  left: 0;
}
.ulstyle {
  width: 100%;
  height: auto;
  line-height: 25px;
  padding-left: 5px !important;
  border-top: none;
  background-color: rgb(255, 255, 255);
}
.ulstyle li {
  padding-left: 5px;
  background-color: rgb(255, 255, 255);
}
.ulstyle li:hover {
  background-color: rgb(236, 232, 232);
}
.check_li {
  cursor: pointer;
}
.no_select_list {
  padding: 5px 10px 0 10px;
  color: #918e8e;
}
::v-deep .custom-control-label {
  width: 95%;
}
.normalStyle {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}
.errorStyle {
  background-color: rgb(255, 220, 221);
  border-color: red;
  border: 1;
}
</style>
